import { observer } from 'mobx-react-lite';
import { useDate, useProfile } from 'state';

const getGreetingText = (date) => {
  const h = date.getHours();
  if (h < 4) return 'Hello';
  if (h < 12) return 'Good morning';
  if (h < 18) return 'Good afternoon';

  return 'Good evening';
};

/**
 * GreetingText
 *
 * @return {JSX.Element}
 */
const GreetingText = () => {
  const { value: date } = useDate();
  const {
    data: { firstName },
  } = useProfile();

  return (
    <>
      {getGreetingText(date)}, {firstName}
    </>
  );
};

GreetingText.displayName = 'GreetingText';

export default observer(GreetingText);
